module.exports = __webpack_public_path__ + "static/classhook-logo-ff8aa6057c26e4c497644ff671ebbcb8.svg";